// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","455":"0d7833a2","977":"fa8bdf19"}[chunkId] + ".chunk.js";
};